<script>
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import estadosBr from '@/constants/estados'
import { mapActions } from 'vuex'

export default {
  components: {
    InputSelect
  },
  props: {
    nomeAba: {
      type: String,
      required: true
    },
    UF: {
      default: null
    },
    municipioNome: {
      default: null
    },
    municipioId: {
      default: null
    },
    endereco: {
      type: Object,
      default: null
    },
    titleUF: {
      type: String,
      default: 'UF de naturalidade'
    },
    titleMunicipio: {
      type: String,
      default: 'Município de naturalidade'
    },
    columnSizeUFMunicipio: {
      type: Number,
      default: 6
    },
    ufObrigatorio: {
      type: Boolean,
      default: false
    },
    municipioObrigatorio: {
      type: Boolean,
      default: false
    },
    marginLeftInicio: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      estadosBrasileiros: [],
      municipiosBrasileiros: []
    }
  },
  watch: {
    'endereco.municipio.codigoEstado': {
      async handler (oldval, newval) {
        if (oldval !== newval && this.endereco.municipio.codigoEstado) {
          const municipios = await this.getMunicipiosByUf(oldval)
          this.municipiosBrasileiros = municipios.map(municipio => { return {id: municipio.id, nome: municipio.nome} })
        }
      }
    }
  },
  mounted () {
    this.estadosBrasileiros = estadosBr.map(estado => { return {id: estado.codigo, nome: estado.nome} })
    this.carregarMunicipios()
  },
  methods: {
    ...mapActions({
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),

    async carregarMunicipios () {
      const codigoEstado = this.endereco?.municipio?.codigoEstado || this.UF
      if (codigoEstado) {
        const municipios = await this.getMunicipiosByUf(codigoEstado)
        this.municipiosBrasileiros = municipios.map(({ id, nome }) => ({ id, nome }))
      }
    },

    async updateUF (sigla) {
      if (sigla) {
        const municipios = await this.getMunicipiosByUf(sigla)
        this.municipiosBrasileiros = municipios.map(municipio => { return {id: municipio.id, nome: municipio.nome} })
      }
      if (this.endereco) {
        this.endereco.municipio = { id: null, nome: null, codigoEstado: sigla }
      } else {
        this.$emit('update:UF', sigla)
        this.$emit('update:municipioId', null)
        this.$emit('update:municipioNome', null)
      }
    },
    updateMunicipio (val) {
      if (val) {
        if (this.endereco) {
          const municipio = this.municipiosBrasileiros.find(m => m.id === val)
          this.endereco.municipio.id = municipio.id
          this.endereco.municipio.nome = municipio.nome
        } else {
          this.$emit('update:municipioId', val)
          this.$emit('update:municipioNome', this.municipiosBrasileiros.find(m => m.id === val).nome)
        }
      } else {
        if (this.endereco) {
          this.endereco.municipio = { id: null, nome: null, codigoEstado: this.endereco.municipio?.codigoEstado }
        }
        this.$emit('update:municipioId', null)
        this.$emit('update:municipioNome', null)
      }
    }
  }
}
</script>

<template>
  <div>
    <InputSelect
      :label="titleUF"
      :obrigatorio="ufObrigatorio"
      :rulesInput="ufObrigatorio ? 'required' : ''"
      :opcoes="estadosBrasileiros"
      :nomeAba="nomeAba"
      :widthColumn="columnSizeUFMunicipio"
      :value="endereco ? endereco.municipio.codigoEstado : UF"
      @input="updateUF"
      :marginLeft="marginLeftInicio"
    />
    <InputSelect
      :label="titleMunicipio"
      :obrigatorio="municipioObrigatorio"
      :ufObrigatorio="municipioObrigatorio ? 'required' : ''"
      :opcoes="municipiosBrasileiros"
      :nomeAba="nomeAba"
      :marginLeft="true"
      :widthColumn="columnSizeUFMunicipio"
      :value="endereco && endereco.municipio ? endereco.municipio.id : municipioId"
      @input="updateMunicipio"
    />
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/FormulariosProntos/UFMunicipio/UFMunicipio.vue